(() => {
  document.querySelectorAll('[data-chn]').forEach(root => {
    if (root.dataset.chnReady) return;
    root.dataset.chnReady = 'true';
    const toggle = root.querySelector('[data-chn-toggle]');
    const all = root.querySelector('[data-chn-all]');
    if (!toggle || !all) return;
    const close = () => {
      all.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      root.removeAttribute('data-chn-open');
    };
    const open = () => {
      all.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      root.setAttribute('data-chn-open', '');
    };
    toggle.addEventListener('click', () => (all.hidden ? open() : close()));
    document.addEventListener('click', event => {
      if (!all.hidden && !root.contains(event.target)) close();
    });
    root.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !all.hidden) { close(); toggle.focus(); }
    });
  });
})();
